import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import useRegisterInput from '@afosto/app-components-react/Form/useRegisterInput';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import validationSchema from './validations';
import translations from './translations';

const PositionForm = ({ locationId, position, onSubmit, suggestions }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    defaultValues: {
      locationId,
      position: position ?? '',
    },
    onSubmit: async formData => {
      if (onSubmit) {
        onSubmit({ ...formData, position: formData?.position?.toUpperCase() });
      }
    },
  });

  useRegisterInput('locationId', true, form);

  const { setValue, watch } = form;
  const positionValue = watch('position');

  const handleSuggestionClick = value => {
    setValue('position', value);
  };

  const selectContentOnFocus = event => event.target.select();

  return (
    <Form form={form} renderActions={false}>
      {suggestions?.length > 0 && (
        <List dense disablePadding>
          {suggestions
            .filter(suggestion => suggestion !== positionValue && suggestion !== '')
            .map(suggestion => (
              <ListItem
                key={suggestion}
                button
                onClick={() => handleSuggestionClick(suggestion)}
                disableGutters
              >
                <ListItemText primary={suggestion} primaryTypographyProps={{ color: 'primary' }} />
              </ListItem>
            ))}
        </List>
      )}
      <TextField
        name="position"
        label={intl.formatMessage(translations.fields.position)}
        autoFocus
        onFocus={selectContentOnFocus}
      />
    </Form>
  );
};

PositionForm.propTypes = {
  locationId: PropTypes.string,
  position: PropTypes.string,
  onSubmit: PropTypes.func,
  suggestions: PropTypes.array,
};

PositionForm.defaultProps = {
  locationId: undefined,
  position: null,
  onSubmit: undefined,
  suggestions: null,
};

export default PositionForm;
